import React, { FunctionComponent } from "react";
import { UtilityBillByIdDTO } from "api";
import { UtilityBillFormView } from "./utility-bill-form-view";

export const UtilityBillFormViewForEdit: FunctionComponent<{
  utilityBill: UtilityBillByIdDTO;
  isLoading: boolean;
}> = ({ utilityBill, isLoading }) => (
  <UtilityBillFormView
    utilityBill={utilityBill}
    isLoading={isLoading}
  />
);

